(function () {
  'use strict';

  if (window.__pePrecisionBrushGiftInit) return;
  window.__pePrecisionBrushGiftInit = true;

  const THRESHOLD_CENTS = 7500;
  const PAID_VARIANT_ID = 52057971687761;
  const FREE_VARIANT_ID = 53754291421521;
  const PAID_PRODUCT_ID = 10406363857233;
  const FREE_PRODUCT_ID = 10799295332689;
  const SHIPPING_PROTECTION_VARIANT_ID = 53435807138129;
  const AUTO_GIFT_KEY = 'precision_brushes_75';
  const DECLINED_STORAGE_KEY = 'pe-precision-brush-gift-declined';
  const SOURCE_AUTO = 'threshold_auto';
  const ELIGIBLE_TITLE_PHRASE = 'schilderen op nummer';
  const ELIGIBLE_HANDLE_PREFIX = 'schilderen-op-nummer';
  const ELIGIBLE_COLLECTION_HANDLE = 'schilderen-op-nummer';
  const ELIGIBLE_PRODUCTS_CACHE_KEY = 'pe-precision-brush-eligible-products-v1';
  const ELIGIBLE_PRODUCTS_CACHE_TTL = 30 * 60 * 1000;
  const GIFT_TITLE_MATCH = 'precisie penselen';
  const INTERNAL_FETCH_OPTION = '__pePrecisionBrushGiftInternal';
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?/;
  const CART_ADD_PATTERN = /\/cart\/add(\.js)?/;

  let isProcessing = false;
  let isMutating = false;
  let hasQueuedRun = false;
  let debounceTimer = 0;
  let lastKnownFreeGiftCount = 0;
  let lastKnownQualifies = false;
  let hasConfirmedCartState = false;
  let isGiftMutationInFlight = false;
  let eligibleProductIds = null;
  let eligibleProductHandles = null;
  let eligibleProductsPromise = null;
  let cartFetchFailureCount = 0;
  let reconcilePausedUntil = 0;

  function getRoute(key, fallback) {
    if (window.routes && window.routes[key]) return window.routes[key];
    if (window.theme && window.theme.routes && window.theme.routes[key]) return window.theme.routes[key];
    return fallback;
  }

  function normalizeCartUrl(route, fallback) {
    const value = getRoute(route, fallback);
    return value.endsWith('.js') ? value : `${value}.js`;
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (input?.url) return input.url;
    return '';
  }

  function isCartAddRequest(requestUrl) {
    return CART_ADD_PATTERN.test(requestUrl);
  }

  function getGiftDeclined() {
    try {
      return window.sessionStorage.getItem(DECLINED_STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setGiftDeclined(value) {
    try {
      if (value) {
        window.sessionStorage.setItem(DECLINED_STORAGE_KEY, 'true');
      } else {
        window.sessionStorage.removeItem(DECLINED_STORAGE_KEY);
      }
    } catch (error) {
      // Ignore storage errors in private browsing modes.
    }
  }

  function isReconcilePaused() {
    return Date.now() < reconcilePausedUntil;
  }

  function noteCartFetchFailure() {
    cartFetchFailureCount += 1;

    if (cartFetchFailureCount >= 2) {
      reconcilePausedUntil = Date.now() + 5000;
    }
  }

  function noteCartFetchSuccess() {
    cartFetchFailureCount = 0;
    reconcilePausedUntil = 0;
  }

  function itemVariantId(item) {
    return Number(item?.variant_id || item?.id || 0);
  }

  function itemProductId(item) {
    return Number(item?.product_id || 0);
  }

  function itemQuantity(item) {
    return Number(item?.quantity || 0);
  }

  function isManagedFreeGift(item) {
    return itemVariantId(item) === FREE_VARIANT_ID || itemProductId(item) === FREE_PRODUCT_ID;
  }

  function isPaidBrush(item) {
    return itemVariantId(item) === PAID_VARIANT_ID || itemProductId(item) === PAID_PRODUCT_ID;
  }

  function isShippingProtection(item) {
    return itemVariantId(item) === SHIPPING_PROTECTION_VARIANT_ID;
  }

  function isExcludedTriggerItem(item) {
    return !item || isManagedFreeGift(item) || isPaidBrush(item) || isShippingProtection(item);
  }

  function isDiamondPainting(item) {
    const title = String(item?.product_title || item?.title || '').toLowerCase();
    const handle = String(item?.handle || '').toLowerCase();
    const url = String(item?.url || '').toLowerCase();

    const productType = String(item?.product_type || '').toLowerCase();

    return productType.includes('diamond')
      || productType.includes('diamant')
      || title.includes('diamond')
      || handle.includes('diamond')
      || url.includes('diamond')
      || title.includes('diamant')
      || handle.includes('diamant')
      || url.includes('diamant');
  }

  function applyEligibleProductsCache(products) {
    const ids = new Set();
    const handles = new Set();

    products.forEach((product) => {
      const id = Number(product?.id || 0);
      const handle = String(product?.handle || '').toLowerCase();

      if (id) ids.add(id);
      if (handle) handles.add(handle);
    });

    eligibleProductIds = ids;
    eligibleProductHandles = handles;
  }

  function readEligibleProductsCache() {
    try {
      const cached = JSON.parse(window.sessionStorage.getItem(ELIGIBLE_PRODUCTS_CACHE_KEY) || 'null');
      if (!cached || !Array.isArray(cached.ids) || !Array.isArray(cached.handles)) return false;
      if (!cached.updatedAt || Date.now() - Number(cached.updatedAt) > ELIGIBLE_PRODUCTS_CACHE_TTL) return false;

      applyEligibleProductsCache([
        ...cached.ids.map((id) => ({ id })),
        ...cached.handles.map((handle) => ({ handle })),
      ]);

      return true;
    } catch (error) {
      return false;
    }
  }

  function writeEligibleProductsCache(products) {
    try {
      const ids = [];
      const handles = [];

      products.forEach((product) => {
        const id = Number(product?.id || 0);
        const handle = String(product?.handle || '').toLowerCase();

        if (id) ids.push(id);
        if (handle) handles.push(handle);
      });

      window.sessionStorage.setItem(ELIGIBLE_PRODUCTS_CACHE_KEY, JSON.stringify({ ids, handles, updatedAt: Date.now() }));
    } catch (error) {
      // Cache is an optimization; the heuristic fallback still works without it.
    }
  }

  function isEligiblePainting(item) {
    if (isExcludedTriggerItem(item)) return false;

    const title = String(item.product_title || item.title || '').toLowerCase();
    const handle = String(item.handle || '').toLowerCase();
    const url = String(item.url || '').toLowerCase();

    if (isDiamondPainting(item)) {
      return false;
    }

    if (title.includes(ELIGIBLE_TITLE_PHRASE)
      || handle.startsWith(ELIGIBLE_HANDLE_PREFIX)
      || url.includes(`/products/${ELIGIBLE_HANDLE_PREFIX}`)) {
      return true;
    }

    return Boolean(
      (eligibleProductIds && eligibleProductIds.has(itemProductId(item)))
      || (eligibleProductHandles && eligibleProductHandles.has(handle))
    );
  }

  function getLinePriceCents(item) {
    const finalLinePrice = Number(item?.final_line_price);
    if (!Number.isNaN(finalLinePrice) && finalLinePrice >= 0) {
      return finalLinePrice;
    }

    const linePrice = Number(item?.line_price);
    if (!Number.isNaN(linePrice) && linePrice >= 0) {
      return linePrice;
    }

    const originalLinePrice = Number(item?.original_line_price);
    if (!Number.isNaN(originalLinePrice) && originalLinePrice >= 0) {
      return originalLinePrice;
    }

    const price = Number(item?.original_price || item?.price || 0);
    return price * itemQuantity(item);
  }

  function deriveState(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const freeLines = [];
    let cartSubtotal = 0;
    let hasEligiblePainting = false;
    const hasDiamondPainting = items.some(item => itemQuantity(item) > 0 && isDiamondPainting(item));

    items.forEach((item) => {
      if (isManagedFreeGift(item)) {
        freeLines.push(item);
        return;
      }

      if (isShippingProtection(item)) {
        return;
      }

      cartSubtotal += getLinePriceCents(item);

      if (isPaidBrush(item)) {
        return;
      }

      if (isEligiblePainting(item)) {
        hasEligiblePainting = true;
      }
    });

    // Only a complete /cart.js response contains the authoritative total after
    // both product and order discounts. /cart/add.js returns a partial payload.
    const total = cart?.total_price;
    const excluded = items.filter(item => isManagedFreeGift(item) || isShippingProtection(item))
      .reduce((sum, item) => sum + getLinePriceCents(item), 0);
    cartSubtotal = typeof total === 'number' && Number.isFinite(total)
      ? Math.max(0, total - excluded) : 0;

    return {
      cart,
      freeLines,
      cartSubtotal,
      hasEligiblePainting,
      hasDiamondPainting,
      qualifies: !hasDiamondPainting && hasEligiblePainting && cartSubtotal >= THRESHOLD_CENTS,
    };
  }

  function hasVisibleCartItems(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return items.some((item) => !isManagedFreeGift(item) && !isShippingProtection(item));
  }

  function shouldLoadEligibleProducts(cart, state) {
    if (eligibleProductIds || eligibleProductHandles) return false;
    if (!cart || state.hasDiamondPainting || state.hasEligiblePainting || state.cartSubtotal < THRESHOLD_CENTS) return false;

    return (cart.items || []).some((item) => {
      if (isExcludedTriggerItem(item) || isDiamondPainting(item)) return false;
      return itemQuantity(item) > 0;
    });
  }

  async function ensureEligibleProductsCache() {
    if (eligibleProductIds || eligibleProductHandles) return;
    if (readEligibleProductsCache()) return;
    if (eligibleProductsPromise) return eligibleProductsPromise;

    eligibleProductsPromise = (async () => {
      const products = [];
      const collectionUrl = `/collections/${ELIGIBLE_COLLECTION_HANDLE}/products.json`;

      for (let page = 1; page <= 10; page += 1) {
        const response = await fetch(`${collectionUrl}?limit=250&page=${page}`, {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) break;

        const data = await response.json();
        const pageProducts = Array.isArray(data?.products) ? data.products : [];

        products.push(...pageProducts);

        if (pageProducts.length < 250) break;
      }

      if (products.length) {
        applyEligibleProductsCache(products);
        writeEligibleProductsCache(products);
      }
    })().catch(() => {
      // Keep the gift flow alive on the title/handle heuristic if the collection endpoint fails.
    }).finally(() => {
      eligibleProductsPromise = null;
    });

    return eligibleProductsPromise;
  }

  function rememberState(state) {
    lastKnownFreeGiftCount = state?.freeLines?.length || 0;
    lastKnownQualifies = Boolean(state?.qualifies);
    hasConfirmedCartState = true;
  }

  function detectCustomerGiftRemoval(nextState) {
    if (lastKnownQualifies && lastKnownFreeGiftCount > 0 && nextState.qualifies && nextState.freeLines.length === 0) {
      setGiftDeclined(true);
    }
  }

  async function fetchCart() {
    if (isReconcilePaused()) {
      throw new Error('Cart gift sync paused after fetch failures');
    }

    const response = await fetch(normalizeCartUrl('cart_url', '/cart'), {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      noteCartFetchFailure();
      throw new Error(`Cart fetch failed: ${response.status}`);
    }

    try {
      const cart = await response.json();
      noteCartFetchSuccess();
      return cart;
    } catch (error) {
      noteCartFetchFailure();
      throw new Error('Cart fetch returned invalid JSON');
    }
  }

  async function changeLine(key, quantity) {
    if (!key) return null;

    isMutating = true;

    let response;
    try {
      response = await fetch(normalizeCartUrl('cart_change_url', '/cart/change'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        [INTERNAL_FETCH_OPTION]: true,
        body: JSON.stringify({ id: key, quantity }),
      });
    } finally {
      isMutating = false;
    }

    if (!response.ok) {
      throw new Error('Cart line update failed');
    }

    return response.json();
  }

  async function addVariant(variantId, quantity, source) {
    isMutating = true;

    let response;
    try {
      response = await fetch(normalizeCartUrl('cart_add_url', '/cart/add'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        [INTERNAL_FETCH_OPTION]: true,
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: {
                _auto_gift: AUTO_GIFT_KEY,
                _auto_gift_source: source,
              },
            },
          ],
        }),
      });
    } finally {
      isMutating = false;
    }

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    return response.json();
  }

  async function refreshCartFragments() {
    const cartUrl = getRoute('cart_url', '/cart');
    const response = await fetch(`${cartUrl.replace(/\/$/, '')}?section_id=api-cart-items`, {
      headers: { Accept: 'text/html' },
    });

    if (!response.ok) return;

    const html = await response.text();
    const doc = new window.DOMParser().parseFromString(html, 'text/html');
    const apiSummary = doc.querySelector('[data-api-cart-summary]');
    const apiPrice = doc.querySelector('[data-api-cart-price]');
    const summaryHolder = document.querySelector('[data-cart-drawer] [data-cart-summary-holder]') || document.querySelector('[data-cart-summary-holder]');
    const priceHolder = document.querySelector('[data-cart-drawer] [data-cart-price-holder]') || document.querySelector('[data-cart-price-holder]');

    if (apiSummary && summaryHolder) {
      summaryHolder.innerHTML = apiSummary.innerHTML;
    }

    if (apiPrice && priceHolder) {
      priceHolder.innerHTML = apiPrice.innerHTML;
    }
  }

  function isGiftCartNode(node) {
    const itemKey = String(node?.dataset?.item || '');
    return itemKey === String(FREE_VARIANT_ID) || itemKey.startsWith(`${FREE_VARIANT_ID}:`);
  }

  function revealCartNode(node) {
    if (!node) return;

    node.removeAttribute('data-animation');
    node.removeAttribute('data-animation-duration');
    node.removeAttribute('data-animation-delay');
    node.style.opacity = '1';
    node.style.visibility = 'visible';
    node.style.transform = 'none';

    node.querySelectorAll('[data-animation]').forEach((child) => {
      child.removeAttribute('data-animation');
      child.removeAttribute('data-animation-duration');
      child.removeAttribute('data-animation-delay');
      child.style.opacity = '1';
      child.style.visibility = 'visible';
      child.style.transform = 'none';
    });
  }

  async function refreshGiftPresentation() {
    const cartUrl = getRoute('cart_url', '/cart');
    const response = await fetch(`${cartUrl.replace(/\/$/, '')}?section_id=api-cart-items`, {
      headers: { Accept: 'text/html' },
    });

    if (!response.ok) {
      await refreshDrawer();
      return;
    }

    const html = await response.text();
    const doc = new window.DOMParser().parseFromString(html, 'text/html');
    const apiLineItems = doc.querySelector('[data-api-line-items]');
    const apiSummary = doc.querySelector('[data-api-cart-summary]');
    const apiPrice = doc.querySelector('[data-api-cart-price]');
    const itemsHolder = document.querySelector('[data-cart-drawer] [data-items-holder]') || document.querySelector('[data-items-holder]');
    const summaryHolder = document.querySelector('[data-cart-drawer] [data-cart-summary-holder]') || document.querySelector('[data-cart-summary-holder]');
    const priceHolder = document.querySelector('[data-cart-drawer] [data-cart-price-holder]') || document.querySelector('[data-cart-price-holder]');

    if (!apiLineItems || !itemsHolder) {
      await refreshDrawer();
      return;
    }

    itemsHolder.querySelectorAll('.cart__item').forEach((node) => {
      if (isGiftCartNode(node)) {
        node.remove();
      }
    });

    const giftNode = Array.from(apiLineItems.querySelectorAll('.cart__item')).find(isGiftCartNode);

    if (giftNode) {
      revealCartNode(giftNode);
      itemsHolder.prepend(giftNode);
      itemsHolder.classList.remove('is-hidden');
    }

    if (apiSummary && summaryHolder) {
      summaryHolder.innerHTML = apiSummary.innerHTML;
    }

    if (apiPrice && priceHolder) {
      priceHolder.innerHTML = apiPrice.innerHTML;
    }

    try {
      rememberState(deriveState(await fetchCart()));
    } catch (error) {
      // The next scheduled reconcile will recover state if this read fails.
    }
  }

  async function refreshDrawer() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      await new Promise((resolve) => {
        let settled = false;
        let timer = 0;

        const finish = () => {
          if (settled) return;
          settled = true;

          if (timer) {
            window.clearTimeout(timer);
          }

          document.removeEventListener('theme:cart:change', finish);
          document.removeEventListener('theme:product:added', finish);
          resolve();
        };

        document.addEventListener('theme:cart:change', finish, { once: true });
        document.addEventListener('theme:product:added', finish, { once: true });

        timer = window.setTimeout(finish, 1500);

        try {
          window.cart.getCart();
        } catch (error) {
          finish();
        }
      });
    } else {
      await refreshCartFragments();
    }

    try {
      rememberState(deriveState(await fetchCart()));
    } catch (error) {
      // The next scheduled reconcile will recover state if this read fails.
    }
  }

  async function removeExtraFreeLines(freeLines) {
    if (freeLines[0] && itemQuantity(freeLines[0]) !== 1) {
      await changeLine(freeLines[0].key, 1);
    }

    for (let index = 1; index < freeLines.length; index += 1) {
      await changeLine(freeLines[index].key, 0);
    }
  }

  async function reconcile() {
    if (isProcessing) {
      hasQueuedRun = true;
      return;
    }

    isProcessing = true;

    try {
      const cart = await fetchCart();
      let state = deriveState(cart);
      let changed = false;

      if (shouldLoadEligibleProducts(cart, state)) {
        await ensureEligibleProductsCache();
        state = deriveState(cart);
      }

      detectCustomerGiftRemoval(state);

      if (!state.qualifies) {
        setGiftDeclined(false);
      }

      if (state.qualifies) {
        if (state.freeLines.length > 1 || (state.freeLines[0] && itemQuantity(state.freeLines[0]) !== 1)) {
          await removeExtraFreeLines(state.freeLines);
          changed = true;
          state = deriveState(await fetchCart());
        }

        if (state.freeLines.length === 0 && !getGiftDeclined() && !isGiftMutationInFlight) {
          isGiftMutationInFlight = true;

          try {
            await addVariant(FREE_VARIANT_ID, 1, SOURCE_AUTO);
            changed = true;
            state = deriveState(await fetchCart());
          } finally {
            isGiftMutationInFlight = false;
          }
        }
      } else if (state.freeLines.length > 0) {
        for (const freeLine of state.freeLines) {
          await changeLine(freeLine.key, 0);
          changed = true;
        }
        state = deriveState(await fetchCart());
      }

      if (changed) {
        if (hasVisibleCartItems(state.cart)) {
          await refreshGiftPresentation();
        } else {
          await refreshDrawer();
        }
      }

      rememberState(state);
    } catch (error) {
      // Keep checkout usable if a gift sync request fails.
      window.console?.warn?.('Precision brush gift sync failed', error);
    } finally {
      isProcessing = false;

      if (hasQueuedRun) {
        hasQueuedRun = false;
        scheduleReconcile(100);
      }
    }
  }

  function scheduleReconcile(delay = 250) {
    if (isReconcilePaused()) {
      return;
    }

    if (debounceTimer) {
      window.clearTimeout(debounceTimer);
    }

    debounceTimer = window.setTimeout(() => {
      debounceTimer = 0;
      reconcile();
    }, delay);
  }

  function scheduleReconcileBurst(delay = 150) {
    scheduleReconcile(delay);
    window.setTimeout(() => scheduleReconcile(0), delay + 900);
  }

  function installFetchHook() {
    if (window.__pePrecisionBrushGiftFetchHook) return;
    window.__pePrecisionBrushGiftFetchHook = true;

    const originalFetch = window.fetch;
    window.fetch = function precisionBrushGiftFetch(input, init) {
      const requestUrl = getRequestUrl(input);
      const isInternalRequest = Boolean(init && init[INTERNAL_FETCH_OPTION]);

      return originalFetch.apply(this, arguments).then((response) => {
        if (!isInternalRequest && CART_MUTATION_PATTERN.test(requestUrl) && response.ok) {
          scheduleReconcileBurst(150);
        }

        return response;
      });
    };
  }

  function installXhrHook() {
    if (window.__pePrecisionBrushGiftXhrHook || !window.XMLHttpRequest) return;
    window.__pePrecisionBrushGiftXhrHook = true;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function precisionBrushGiftXhrOpen(method, url) {
      this.__pePrecisionBrushGiftUrl = getRequestUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function precisionBrushGiftXhrSend() {
      const requestUrl = this.__pePrecisionBrushGiftUrl || '';

      if (CART_MUTATION_PATTERN.test(requestUrl)) {
        this.addEventListener('loadend', async () => {
          const status = Number(this.status || 0);
          if (status < 200 || status >= 300 || isReconcilePaused()) {
            return;
          }

          scheduleReconcileBurst(150);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('theme:product:added', () => scheduleReconcileBurst(150));
  document.addEventListener('theme:cart:open', () => scheduleReconcile(250));
  document.addEventListener('theme:cart:change', () => scheduleReconcile(250));
  document.addEventListener('theme:cart:update', () => scheduleReconcileBurst(150));
  document.addEventListener('cart:updated', () => scheduleReconcileBurst(150));

  window.peEnsurePrecisionBrushGift = async function () {
    const deadline = Date.now() + 10000;
    while (isProcessing || isGiftMutationInFlight) {
      if (Date.now() > deadline) throw new Error('Je winkelwagen wordt nog bijgewerkt. Probeer het opnieuw.');
      await new Promise(resolve => window.setTimeout(resolve, 50));
    }
    if (debounceTimer) { window.clearTimeout(debounceTimer); debounceTimer = 0; }
    await reconcile();
    const state = deriveState(await fetchCart());
    const count = state.freeLines.reduce((sum, item) => sum + itemQuantity(item), 0);
    if ((!state.qualifies && count > 0) || count > 1 || (state.qualifies && !getGiftDeclined() && count !== 1)) {
      throw new Error('Je cadeau kon nog niet worden bijgewerkt. Probeer het opnieuw.');
    }
  };

  window.addEventListener('pageshow', () => scheduleReconcile(100));
  installFetchHook();
  installXhrHook();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleReconcileBurst(500), { once: true });
  } else {
    scheduleReconcileBurst(500);
  }
})();
